import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentsVerifyRoutingModule } from './documents-verify-routing.module';
import { ComplianceDocumentsComponent } from './components/compliance-documents/compliance-documents.component';
import {AgGridModule} from 'ag-grid-angular';
import {FormsModule} from '@angular/forms';
import { ClaimsDenialsComponent } from './components/claims-denials/claims-denials.component';
import {ComunicationDashboard} from '../dashboard-providers/comunication-dashboard';


@NgModule({
  imports: [
    CommonModule,
    DocumentsVerifyRoutingModule,
    AgGridModule.withComponents([]),
    FormsModule,
  ],
  exports: [
    ComplianceDocumentsComponent, ClaimsDenialsComponent
  ],
  declarations: [ComplianceDocumentsComponent, ClaimsDenialsComponent],
  providers: [
    ComunicationDashboard
  ]
})
export class DocumentsVerifyModule { }



// WEBPACK FOOTER //
// ./src/app/pages/documents-verify/documents-verify.module.ts